import React from "react";
import { ProductType } from "@components/Dashboard/pages/Products/components/CreationEditingLayout/types";
import { useFormContext, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "@redux/hooks";
import { formatPriceWithCurrency } from "@helpers/utils";
import { Typography } from "@mui/material";

export default function GrossVatPriceField() {
    const { t } = useTranslation("", { keyPrefix: "products.general" });

    const baseCurrency = useAppSelector(
        (state) => state.auth.user?.company?.currency
    );

    const { control } = useFormContext<ProductType>();

    const sale = useWatch({
        control,
        name: "prices.sale",
    });

    const tax = useWatch({
        control,
        name: "general.tax",
    });

    const grossPrice = Number(sale ?? 0) * (1 + (tax?.rate ?? 0) / 100);
    const hasDefaultVat = Boolean(tax);

    return (
        <Typography
            variant="caption"
            display="block"
            sx={{ color: "rgba(60, 55, 105, 0.5)" }}
        >
            {t("fields.priceInclVat")}:{" "}
            <span style={{ color: hasDefaultVat ? "#7556FA" : "inherit" }}>
                {formatPriceWithCurrency(grossPrice, baseCurrency)}
            </span>
        </Typography>
    );
}
